import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

window.addEventListener('storage', (event) => {
    if (event.key === 'default_auth_token') {
        store.commit('SET_TOKEN', event.newValue);
    }
});

const state = {
    user: {},
    token: window.localStorage.getItem('default_auth_token') || null,
};

const getters = {
    isAuthenticated(state) {
        return !!state.token;
    },
    getUser: (state) => state.user,
    getFullName: (state) => `${state.user.profile.name}`,
    getAvatarText: (state) => `${state.user.profile.name.charAt(0)}`,
    getEmail: (state) => state.user.profile.family_name,
    getAccessToken: (state) => state.token || '',
};

const mutations = {
    SET_TOKEN(state, token) {
        state.token = token;
        if (token) {
            window.localStorage.setItem('default_auth_token', token);
        } else {
            window.localStorage.removeItem('default_auth_token');
        }
    },
    SET_USER(state, user) {
        state.user = user.profile;
    },
    REMOVE_TOKEN(state) {
        window.localStorage.removeItem('default_auth_token');
        state.token = null;
        state.user = {};
    },
};

const actions = {
    logout({ commit }) {
        commit('REMOVE_TOKEN');
    },
    setUser({ commit }, user) {
        commit('SET_USER', user);
    },
    setToken({ commit }, token) {
        commit('SET_TOKEN', token);
    },
};

export default new Vuex.Store({
    state,
    mutations,
    getters,
    actions,
});



// WEBPACK FOOTER //
// ./src/store.js